@import '../../../../styles/teamscale_variables';
@import '../../../../styles/teamscale_tables';
@import '../../../../styles/teamscale_tables';
@import '../../../../styles/teamscale_variables';

.ts-findings-filter-component {
	.finding-filter-tabs:global(.ui.secondary.tabular.menu) {
		display: flex;
		width: 100%;
		margin-bottom: 0 !important;

		:global(.item) {
			flex-grow: 1;
			padding-left: 1em;
			padding-right: 1em;
		}
	}

	:global(.ui.basic.segment) {
		margin-top: 0 !important;
		margin-bottom: 0 !important;
		padding-left: 0 !important;
		padding-right: 0 !important;
	}

	:global(.tab) {
		padding-left: 0.5em;

		:global(.header) {
			margin-top: 1em;
			margin-bottom: 0.8em;
		}

		:global(.fields) {
			margin-left: 0;

			+ :global(.fields),
			+ :global(.field) {
				margin: 1em 0;
			}
		}
	}
}

.apply-button-container {
	width: 100%;
	display: flex;
	justify-content: flex-end;
	margin-bottom: 0.5em;
}

.bottom-apply-button {
	margin-bottom: 2em !important;
}
